import React from 'react';
import { Modal } from 'antd';
import { CheckCircleOutlined, CheckCircleFilled } from '@ant-design/icons';
import './index.less';
import goto from '@/common/goto';

function GotoDetailModal(props: { visible: boolean; roomId: string | null; activityId: string | null }) {
  const { visible } = props;
  return (
    <Modal
      closable={false}
      getContainer={false}
      width={520}
      className="goto-detail-modal"
      title={
        <div className="goto-detail-modal-title">
          <div className="first-line">
            <CheckCircleFilled className="anticon" />
            <span>活动创建成功</span>
          </div>
          <div className="connect-line"></div>
          <div className="second-line">
            <CheckCircleOutlined className="anticon" />
            <span>继续完成策略创建和素材创建吧~</span>
          </div>
        </div>
      }
      visible={visible}
      footer={null}
    >
      <div className="activity-type-body">
        <div className="to-celue" onClick={() => goto.dailyGoodsStrategyNew(props.roomId, props.activityId).push()}>
          <div className="version">去建商品策略</div>
          <div className="deliver" />
          <div className="text">创建规则筛选您想要的商品素材！并且可以进一步筛选商品素材组使用。</div>
          <img
            className="img-new"
            src="//img30.360buyimg.com/pop/jfs/t1/85628/32/24682/7046/62332499E148bedcb/aa0ab249ab419d52.png"
          />
        </div>
        <div className="to-sucai" onClick={() => goto.myCreateActivityDetailMaterials(props.activityId).push()}>
          <div className="version">去创建素材</div>
          <div className="deliver" />
          <div className="text">
            通过分配提报（原提报流程）、规则直选（直接选品）等方式生成商品组/广告组关联前台页面。
          </div>
        </div>
      </div>
      <div className="jump-to" onClick={() => goto.myCreateActivityDetailMaterials(props.activityId).push()}>
        暂时跳过
      </div>
    </Modal>
  );
}

export default GotoDetailModal;
